import script from "./AvanceProcesoView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AvanceProcesoView.vue?vue&type=script&lang=ts&setup=true"

import "./AvanceProcesoView.vue?vue&type=style&index=0&id=5dbc0ce7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dbc0ce7"]])

export default __exports__